import { merge } from 'lodash';
import { AnyStateMachine } from 'xstate';
import { EnrollmentMachine } from '~/machines/enrollment-selection';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { BillUpload, BillUploadProps } from './bill-upload.component';

type BillUploadContainerProps = {
  micro: ContextSendMatch<EnrollmentMachine>;
  funnel: ContextSendMatch<AnyStateMachine>;
  overrideCopy?: BillUploadProps['overrideCopy'];
  overrideProps?: DeepPartial<BillUploadProps>;
};

export const BillUploadContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: BillUploadContainerProps) => {
  const props: BillUploadProps = {
    context: {
      files: context.files,
      pagesRequired: context.pagesRequired ?? 2,
      maxPages: context.maxPages ?? 2,
      user: context.funnelPacket.user,
      utility: context.funnelPacket.utility,
    },
    goTo: {
      credentials: context.showUtilityConnectButton
        ? () => send({ type: 'CHOOSE_UTILITY_CONNECT' })
        : undefined,
    },
    next: () => send({ type: 'SUBMIT_BILLS' }),
    onDelete: id => send({ type: 'DELETE_FILE', id }),
    onUploadFailure: fileRejection => send({ type: 'UPLOAD_FAILURE', file: fileRejection }),
    onUploadSuccess: (file, base64Image) => send({ type: 'UPLOAD_SUCCESS', file, base64Image }),
    overrideCopy,
    pending: !matches('billUpload.idle'),
  };

  return <BillUpload {...merge(props, overrideProps)} />;
};
